import React from 'react';

const MeasurementsPageSimple: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">My Measurements</h1>
          <p className="text-gray-600 mt-2">Measurements taken by your tailors</p>
        </div>

        {/* No Measurements Message */}
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <div className="text-6xl mb-4">📏</div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">No Measurements Yet</h3>
          <p className="text-gray-600 mb-4">
            Your measurements will appear here after your tailor takes them during an appointment.
          </p>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-blue-800 text-sm">
              <strong>Next Step:</strong> Book an appointment with a tailor to get your measurements taken.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeasurementsPageSimple;